package us.laantech.common.dto

import kotlinx.serialization.Serializable

//import us.laantech.common.dto.CartItem


enum class TransactionStatusType {
    INITIALIZED, // The transaction has been created but not yet processed

    // Intermediate states
    PROCESSING, // The transaction is being processed (Cash/Card/EBT/etc)
    PARTIAL, // Partial Payment received
    CANCELLED, // Transaction was canceled
    SUSPENDED, // Transaction was suspended

    // Final states
    COMPLETE, // Finalized transaction
    FAILED, // Transaction failed
    VOIDED, // Transaction was voided
}

@Serializable
data class TransactionStatus(
    val updatedAt: Long?,
    val status: TransactionStatusType?,
)


enum class TransactionEvent {
    INITIALIZED,
    UPDATE_ITEMS,
    UPDATE_STATUS,
    CASH_TENDERED,
    CHANGE_TENDERED,
}

@Serializable
enum class CardPaymentType {
    DEBIT,
    CREDIT,
    EBT
}

@Serializable
enum class CardTransactionStatus {
    APPROVED,
    DECLINED,
    INSUFFICIENT,
    PARTIAL,
    UNKNOWN,
    ABORTED,
    TIMEOUT,
    INVALID,
    NOT_FOUND
}

@Serializable
enum class CardTransactionType {
    SALE,
    REFUND,
    OTHER
}

@Serializable
data class CardTransaction(

    val cardPaymentType: CardPaymentType?,
    val cardType: String?,
    val cardTransactionType: CardTransactionType?,
    
    // The card was used at this time
    val createdAt: Long?,

    // This amount was charged
    val amountCents: Long?,

    // To this card identified by the last four digits.
    // Use lastFour + expiry to enforce refunds to go to same card
    val lastFour: String?,
    val expiry: String?,

    // By this NFC App
    val appLabel: String?,

    // With this authorization
    val authCode: String?,
    val aid: String?,

    // ECR Ref/trace
    val ecrRef: String?,
    val terminal: String?,

    val status: CardTransactionStatus?,
    val statusMessage: String?,

    //TODO  Required to display on receipt for EBT transactions
    val cardBalance: String?,

    // TODO show on receipt
    val cashBackAmountCents: Long?
)


@Serializable
data class StoreExpense(
    val title: String?,
    val paymentAmountCents: Long?,
    val createdAt: Long?,

    // If payment method is bank transfer
    val bankName: String?,
    val checkNumber: String?,
    val invoiceNumber: String?, // TODO ask what this is
    val checkDate: String?,
    val payoutDate: String?,

    )


@Serializable
data class PosTransactionDTO(

    // This transaction belongs to this account
    val accountSub: String? = null,

    // CompanyBranch has parent company, get from ther if needed
    val parentCompanyUuid: String? = null,

    // This transaction belongs to this branch/store
    val branchUuid: String? = null,

    // This transaction created at this POS
    val posDeviceId: String? = null,

    // This transaction created by this employee
    val employeeUUID: String? = null,

    // The transaction is identified by this receipt barcode
    val transactionId: String? = null,

    val createdAt: Long? = null,
    val updatedAt: Long? = null,
    val statusHistory: List<TransactionStatus> = listOf(),

    // Purchase Info
    val cartItems: List<CartItem> = listOf(),
    val subTotalCents: Long? = null,
    val taxCents: Long? = null,
    val totalCents: Long? = null,
    val cashTenderedAmountCents: Long? = null,
    val changeDueAmountCents: Long? = null,

    // TODO handle cupons and rewards
    val cuponTenderedAmountCents: Long? = null,
    val rewardTenderedAmountCents: Long? = null,

    // Refund Info
    val refundedItems: List<CartItem> = listOf(),
    val cashRefundedAmountCents: Long? = null,
    val cardRefundedAmountCents: Long? = null,

    // Payouts
    val payoutInfoDTOS: List<PayoutInfoDTO> = listOf(),
    val cashPayoutAmountCents: Long? = null,
    val cardPayoutAmountCents: Long? = null,

    // expenses
    val storeExpenses: List<StoreExpense> = listOf(),

    // Metadata
    val cardTransactions: List<CardTransaction> = listOf(),
    val cashSafeDropAmountCents: Long? = null,

    // Is read only
    val finalized: Boolean? = null,

    // Security video:
    val securityVideoS3Key: String? = null,

    ) {

//    
//    val cashTenderedAmountCents: Long = cartItems
//        .filter { it.itemType == CartItemType.CASH }
//        // The value of the cash item is negative in the cart so times -1 to get the actual amount
//        .map { -it.priceCents }
//        .reduceOrNull { acc, price -> acc + price } ?: 0L


    val cardTenderedAmountCents: Long = cardTransactions.sumOf { cardTransaction ->
        cardTransaction.amountCents?.let {
            if (it > 0) it
            else 0L
        } ?: 0L
    }


//    fun getNetPayout(byCartItemType: CartItemType?): BigDecimal {
//
//        val payout = payoutItems
//            .filter { byCartItemType == null || it.itemType == byCartItemType }
//            .sumOf { it.priceCents.toBigDecimalDollarsFromCents() }
//
//        return payout
//    }


    fun getLatestStatus(): TransactionStatusType? {
        return statusHistory.maxByOrNull { it.updatedAt ?: Long.MIN_VALUE }?.status
    }



}

